<template>
  <div id="launch" class="settings mt-5">
  </div>
</template>

<script>
import { sync } from "vuex-pathify";
import store from "../store";
import vx_api from "../vuemix";

export default {
  name: "download",
  data() {
    return {
      launch_proto: "",
    }
  },
  components: {
  },
  created() {
  },
  methods: {
    launchApp: function() {
      let vue = this;
      eraseLocal("vx_page_href");
      window.try_launch_app("" + vue.launch_proto + window.location.host,
        function(w) {
          console.log("Launched",w);
        });
    },
  },
  computed: {
  },
  mounted() {
    let vue = this;
    let plat = window.navigator.platform;
    if (/Mac/i.test(plat)) {
      vue.launch_proto = "vxstreamer://";
    } else if (/(Win32|Win64)/i.test(plat)) {
      vue.launch_proto = "vxstreamer://";
    } else if (/(iPhone|iPod|iPad)/i.test(plat)) {
      vue.launch_proto = "vxstreamer://";
    } else {
      vue.launch_proto = "vxstreamer://";
    }
    vue.launchApp();
  },
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 760px;
}
</style>
